module.exports = "img/flags/KP.3bd86b3.png";